// Base unit: 4px. Index into the scale for consistent spacing.
// e.g. spacing[3] === 12, spacing[5] === 20
export const spacingBase = 4;
export const spacing = [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 64];
//# sourceMappingURL=spacing.js.map